export const railStyle = {
	backgroundColor: "#E5E5E5"
};

export const trackStyle = {
	backgroundColor: "#E50914"
};
